var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { defaultProps } from './defaults';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import TimeComboBox from './Combobox';
import { WrongFilled } from '@feb-team/legao-icons-react';
import { RangeTimePicker } from './RangeTimePicker';
var TimePicker = /** @class */ (function (_super) {
    __extends(TimePicker, _super);
    function TimePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handerInputClick = function () {
            _this.setState({
                openContext: true,
            });
        };
        /** 此刻 */
        _this.setTimeNow = function (e, selected) {
            if (_this.props.onBeforeChange(_this.state.prevValue, e)) {
                _this.setState({
                    value: selected,
                    inpValStr: selected,
                    prevValue: selected,
                    openContext: false,
                });
                _this.props.onChange(selected, e);
            }
        };
        /** 确定 */
        _this.confirm = function (e, selected) {
            var prevValue = _this.state.prevValue;
            if (_this.props.onBeforeChange(prevValue, e)) {
                if (!_this.state.inpValStr) {
                    _this.inputEl.blur();
                    return;
                }
                if (_this.props.value === undefined) {
                    _this.setState({
                        value: selected,
                    });
                }
                if (prevValue == selected) {
                    _this.setState({
                        openContext: false,
                    });
                }
                else {
                    if (_this.props.value !== undefined) {
                        _this.setState({
                            inpValStr: _this.state.prevValue,
                            openContext: false,
                        });
                    }
                    else {
                        _this.setState({
                            prevValue: selected,
                            inpValStr: selected,
                            openContext: false,
                        });
                    }
                    _this.props.onChange(selected, e);
                }
            }
        };
        /**清除 */
        _this.clearText = function () {
            _this.setState({
                value: '',
                inpValStr: '',
                prevValue: '',
            });
        };
        /**
         * 选择时间
         */
        _this.onSelectTime = function (e, selected, type) {
            if (type === void 0) { type = 'custom'; }
            switch (type) {
                case 'confirm':
                    _this.confirm(e, selected);
                    break;
                case 'now':
                    _this.setTimeNow(e, selected);
                    break;
                default:
                    _this.setState({
                        inpValStr: selected,
                        value: selected,
                    });
                    break;
            }
        };
        /**
         * 鼠标进入
         */
        _this.onMouseEnter = function () {
            _this.props.model == 'single' &&
                _this.setState({
                    allowClear: true,
                });
        };
        /**
         * 鼠标离开
         */
        _this.onMouseLeave = function () {
            _this.props.model == 'single' &&
                _this.setState({
                    allowClear: false,
                });
        };
        var _a = _this.props, defaultValue = _a.defaultValue, value = _a.value;
        var copyValue = defaultValue;
        if (value)
            copyValue = value;
        _this.state = {
            value: copyValue ? copyValue : _this.initTimeDate(),
            inpValStr: copyValue ? copyValue : '',
            prevValue: copyValue ? copyValue : '',
            openContext: false,
            allowClear: false,
            isFocus: false,
        };
        return _this;
    }
    TimePicker.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.model == 'range') {
            if (nextProps && nextProps.value !== this.props.value) {
                this.setState({
                    prevValue: nextProps.value,
                    value: nextProps.value,
                    inpValStr: nextProps.value,
                });
            }
        }
        else {
            if (nextProps && nextProps.value) {
                this.setState({
                    prevValue: nextProps.value,
                    value: nextProps.value,
                    inpValStr: nextProps.value,
                });
            }
        }
    };
    TimePicker.prototype.handerInputChange = function (e) {
        this.setState({
            inpValStr: e.target.value,
            value: e.target.value,
        });
    };
    TimePicker.prototype.handerInputFocus = function (e) {
        this.setState({
            isFocus: true,
        });
        this.props.onFocus(e);
    };
    TimePicker.prototype.handerInputBlur = function (e) {
        var prevValue = this.state.prevValue;
        this.setState({
            inpValStr: prevValue,
            value: prevValue,
            openContext: false,
            isFocus: false,
        });
        this.props.onBlur(e);
    };
    /**
     * 初始化时间
     */
    TimePicker.prototype.initTimeDate = function () {
        return '00:00:00';
    };
    TimePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, model = _a.model, placeholder = _a.placeholder, format = _a.format, bordered = _a.bordered, showIcon = _a.showIcon, children = _a.children, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange, now = _a.now, minuteStep = _a.minuteStep, hourStep = _a.hourStep, secondStep = _a.secondStep, showClear = _a.showClear, nowText = _a.nowText, confirmText = _a.confirmText, onBlur = _a.onBlur, onFocus = _a.onFocus, rest = __rest(_a, ["disabled", "model", "placeholder", "format", "bordered", "showIcon", "children", "onChange", "onBeforeChange", "now", "minuteStep", "hourStep", "secondStep", "showClear", "nowText", "confirmText", "onBlur", "onFocus"]);
        var _b = this.state, openContext = _b.openContext, inpValStr = _b.inpValStr, allowClear = _b.allowClear, isFocus = _b.isFocus;
        var contentCls = [
            model == 'single' ? 'relative' : null,
            'inline-flex',
            model == 'single' ? 'w-px-220' : 'w-px-64',
            'text-sm',
        ];
        var selectCls = ['w-full', 'flex', 'items-center', 'justify-between'];
        var svgBoxCls = [
            'absolute',
            'right-0',
            'mr-px-12',
            'w-4',
            'fill-black',
            'opacity-20',
        ];
        if (bordered) {
            contentCls.push('border', 'border-gray-200', 'rounded');
        }
        if (disabled) {
            contentCls.push('bg-gray-100', 'cursor-not-allowed');
        }
        else {
            contentCls.push('bg-white');
            if (!isFocus) {
                contentCls.push('hover:border-brand-600');
            }
        }
        return (React.createElement(DivTag, __assign({ name: TimePicker.NAME, atomics: contentCls }, rest),
            React.createElement(DivTag, { atomics: selectCls, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, autoPrefixedClassName: "time-picker-contain" },
                React.createElement("input", { className: "time-picker-input border time-picker-input-" + model + " " + (disabled ? 'time-picker-cursor-not-allowed' : 'time-picker-cursor-auto') + " " + (model == 'single' ? 'time-picker-px-px-12' : null) + "  " + (isFocus ? 'time-picker-input-focus' : null) + " " + (isFocus && model == 'single' ? 'shadow-input' : 'border-transparent'), type: "text", placeholder: placeholder, onChange: function (e) { return _this.handerInputChange(e); }, onFocus: function (e) { return _this.handerInputFocus(e); }, onClick: this.handerInputClick, onBlur: function (e) { return _this.handerInputBlur(e); }, value: inpValStr, disabled: disabled, maxLength: 8, ref: function (c) {
                        _this.inputEl = c;
                    } }),
                showIcon && (React.createElement(SpanTag, { atomics: svgBoxCls, autoPrefixedClassName: "time-picker-icon" }, allowClear && inpValStr ? (React.createElement(WrongFilled, { className: 'w-4', onClick: this.clearText })) : null))),
            openContext && (React.createElement(TimeComboBox, { value: this.state.value, format: format, hourStep: hourStep, secondStep: secondStep, minuteStep: minuteStep, showNow: now, nowText: nowText, confirmText: confirmText, onChange: function (e, next, type) { return _this.onSelectTime(e, next, type); } }))));
    };
    TimePicker.RangePicker = RangeTimePicker;
    TimePicker.defaultProps = defaultProps;
    TimePicker.NAME = 'time-picker';
    TimePicker.displayName = 'TimePicker';
    return TimePicker;
}(React.Component));
export { TimePicker };
